var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup68(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0.495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.495)",
    fill: "#11989a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.534,15.79H.261V5.248H3.534ZM1.9,3.81A1.9,1.9,0,1,1,3.792,1.9,1.912,1.912,0,0,1,1.9,3.81Zm13.89,11.98H12.52V10.658c0-1.223-.025-2.791-1.7-2.791-1.7,0-1.963,1.329-1.963,2.7v5.22H5.585V5.248h3.14V6.686H8.77a3.44,3.44,0,0,1,3.1-1.7c3.313,0,3.922,2.182,3.922,5.015V15.79Z",
    transform: "translate(8.316 7.894)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup68);
export default __webpack_public_path__ + "static/media/Group 68.437e64116aa1de30ebddec7dba97c479.svg";
export { ForwardRef as ReactComponent };